<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>From</b-input-group-text>
            </b-input-group-prepend>
            <datepicker
              @dp-change="changeFromDate"
              :value="global.default_from_date"
              :config="options"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>To</b-input-group-text>
            </b-input-group-prepend>
            <datepicker
              @dp-change="changeToDate"
              :value="global.default_to_date"
              :config="options"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon m-0"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <div class="form-group form-actions float-left pb-2">
          <b-button
            class="mr-2 btn"
            variant="success"
            type="submit"
            size="md"
            @click="my_download"
          >
            Generate Report
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          :tbody-tr-class="rowClass"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-if="data.item.StatusCode < 3"
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import datepicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

export default {
  name: "OrderHistory",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        {
          key: "OrderID",
          label: "Order Number",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "DateOrdered",
          label: "Order Date",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "OrderedBy.UserName",
          label: "Ordered By",
          sortable: true,
          thStyle: "width: 20%;"
        },
        {
          key: "AddressLine",
          label: "Ship To",
          sortable: true,
          thStyle: "width: 30%;"
        },
        {
          key: "PointTotal",
          label: "Points",
          sortable: true,
          thStyle: "width: 7%;"
        },
        {
          key: "ItemCount",
          label: "Items",
          sortable: true,
          thStyle: "width: 7%;"
        },
        {
          key: "CurrentStatus.CurrentStatus",
          label: "Status",
          sortable: true,
          thStyle: "width: 11%;"
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: "",
      rowCounter: 0,
      selectedStatus: 2,
      options: {
        format: "MM/DD/YYYY",
        useCurrent: false
      }
    };
  },
  props: {},
  components: {
    cTable,
    StyledDialog,
    datepicker
    //MyBaseTable
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.product.products.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      //console.log(this.totalRowsFiltered);
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["global", "order", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    my_download() {
      var _op = {
        FromDate: this.$store.state.global.default_from_date,
        ToDate: this.$store.state.global.default_to_date,
        SearchString: this.searchString
      };
      this.$store
        .dispatch("order/DownloadOrderReport", _op)
        .then(response =>
          window.open(
            "https://api.miltenyirewards.com/Output/" +
              this.$store.state.order.download_order_history_filename,
            "_blank"
          )
        );
    },
    async changeFromDate(event) {
      await this.$store.dispatch("global/setFromDate", event.target.value);
      this.filterList();
    },
    async changeToDate(event) {
      await this.$store.dispatch("global/setToDate", event.target.value);
      this.filterList();
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.StatusCode == 4) return "table-success";
    },

    async myLoadComponent() {
      await this.$store.dispatch("order/fetchOrders");
      this.filterList();
      await this.$store.dispatch("n_user/fetchUserGroups");
      await this.$store.dispatch("n_user/fetchUsers");
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$store.dispatch("order/loadOrderEdit", record.OrderID).then(() => {
        this.$router.push({ name: "OrderProfile" });
      });
    },
    newEntity() {
      //   this.$store
      //     .dispatch("product/newProduct", this.createFreshObject())
      //     .then(() => {
      //       this.$router.push({ name: "Product" });
      //       //,
      //       //params: { id: this.event.id }
      //     })
      //     .catch(() => {
      //       console.log("There was a problem");
      //       //.dispatch('notification/add', this.event)
      //     });
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshObject() {
      //   return {
      //     ProductID: -1,
      //     ProductName: "",
      //     ProductDesc: "",
      //     ProductShortDesc: "",
      //     Inactive: false
      //   };
    },
    filterList: function() {
      //var _from = Date.parse(this.$store.state.global.default_from_date);
      //console.log(new Date(this.$store.state.global.default_to_date));
      //console.log(this.$store.state.order.orders);
      this.filteredObjects = this.$store.state.order.orders
        .filter(
          porder =>
            new Date(porder.DateOrdered) >=
              new Date(this.$store.state.global.default_from_date) &&
            new Date(porder.DateOrdered) <=
              new Date(this.$store.state.global.default_to_date)
        )
        .filter(
          order =>
            this.searchString == "" ||
            order.OrderID.toString().indexOf(this.searchString) > -1 ||
            order.OrderedBy.UserName.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            order.AddressLine.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            order.DateOrdered.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1
        );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    }
  },
  watch: {
    "$store.state.order.orders.length": function(oldValue, newValue) {
      //console.log(oldValue);
      //console.log(newValue);

      this.filterList();
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
.my-alternating-row-color {
  background-color: rgba(32, 168, 216, 0.15) !important;
  color: red;
}
</style>
